import { LuIcon, Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { nameModelSortFn } from "@overmap-ai/common"
import { useSort, useTextFilter } from "@overmap-ai/hooks"
import { memo, type ReactElement } from "react"

import { assetTypeFilterCallback } from "../../filtering/utils"
import { modelIconMapping } from "../../mappings/icons"
import { AssetTypeSelectGroup, type AssetTypeSelectGroupProps } from "../MenuSelectGroups/AssetTypeSelectGroup"

type AssetTypeSelectProps = Omit<MenuRootProps, "children"> &
	Omit<MenuClickTriggerProps, "children"> &
	MenuVariantProps &
	AssetTypeSelectGroupProps & {
		children: ReactElement
	}

export const AssetTypeSelect = memo<AssetTypeSelectProps>((props) => {
	const {
		// Trigger props
		disabled = false,
		children,
		// MenuContent props
		radius,
		size,
		variant,
		accentColor,
		// AssetTypeSelectGroup group props
		assetTypes,
		showAddAssetType = false,
		required,
		defaultValue,
		value,
		onValueChange,
		...rest
	} = props

	const sortedAssetTypes = useSort(assetTypes, nameModelSortFn)

	const [filteredAssetTypes, filterValue, setFilterValue] = useTextFilter(sortedAssetTypes, assetTypeFilterCallback)

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content size={size} radius={radius} accentColor={accentColor} variant={variant}>
				<Menu.InputRoot>
					<Menu.InputSlot>
						<LuIcon icon={modelIconMapping.search} />
					</Menu.InputSlot>
					<Menu.InputField placeholder="Search" value={filterValue} onValueChange={setFilterValue} />
				</Menu.InputRoot>
				{filteredAssetTypes.length > 0 && <Menu.Separator />}
				<Menu.Scroll>
					{/** TODO: Find away for the type discriminate to work without doing a explicit type check on required */}
					{required ? (
						<AssetTypeSelectGroup
							required={required}
							defaultValue={defaultValue}
							value={value}
							onValueChange={onValueChange}
							assetTypes={filteredAssetTypes}
							showAddAssetType={showAddAssetType}
						/>
					) : (
						<AssetTypeSelectGroup
							required={required}
							defaultValue={defaultValue}
							value={value}
							onValueChange={onValueChange}
							assetTypes={filteredAssetTypes}
							showAddAssetType={showAddAssetType}
						/>
					)}
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
AssetTypeSelect.displayName = "AssetTypeSelect"
